import Indicator from "../Indicator";
import { useContext, useState } from "react";
import { ContextProfileUser } from "../../lib/profileContext";
import { validatePassword, simplyClick } from "../../helpers";
import InputGlobal from "../InputGlobal";
import ButtonGroup from "../ButtonGroup";
import Tooltip from "../Tooltip";

import "./Password.scss";

import Eye from "../../images/eye.svg";
import EyeOff from "../../images/eye-off.svg";
import chatIcon from "../../images/ico_data-chat-message.svg";
import confettiIcon from "../../images/ico_confetti.svg";
import HeartsIcon from "../../images/ico_hearts.svg";
import { joinReasons } from "../../constants/constans";
import LovelyIcon from "../../images/ico_lovely.svg";
import { useWizardAnswers } from "ui-components";
import { useAppendLandingId } from "../../hooks/useAppendLandingId";
import { landingId } from "../../constants/constans";

const Password = ({ step, setStep }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [passwordShow, setPasswordShow] = useState(false);
  const [error, setError] = useState({ password: null, terms: null });
  const [checkBox, setCheckBox] = useState(false);
  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const updateAnswer = useWizardAnswers();
  useAppendLandingId(landingId);

  const handlerSubmit = () => {
    if (!selectedIndicator) {
      updateAnswer({ join_reasons: ["0"] });
    }
    const { status, error: passError } = validatePassword(data.password);

    if (!status) {
      if (!data.password) {
        simplyClick("err_lnd_password_nopassword");
        setError({ ...error, password: "Please enter a password" });
      } else {
        simplyClick("err_lnd_password_shortpassword");
        setError({ ...error, password: passError });
      }
      return;
    }

    if (!checkBox) {
      simplyClick("err_lnd_checkbox_nocheckbox");
      setError({
        ...error,
        terms:
          "Please accept our Terms of Use, Privacy Policy, Cookie Policy, Billing & Refund Policy, and Consent Policy.",
      });
    } else {
      simplyClick("cl_lnd_afm3_password_next");

      setStep(step + 1);
    }
  };
  const handleSelectIndicator = (id) => {
    const selected = joinReasons[id];

    if (!selected) return;
    setSelectedIndicator(selected.label);
    updateAnswer({ join_reasons: [String(id)] });

    if (selected.event) {
      simplyClick(selected.event);
    }
  };

  const handlerAddPassword = (e) => {
    setError({ ...error, password: null });
    setShowTooltip(false);
    setData({ ...data, password: e.target.value });
  };

  const handleCheckBox = (e) => {
    simplyClick("cl_lnd_afm3_password_checkbox_mark");
    setError({ ...error, terms: null });
    setCheckBox(!checkBox);
  };

  const toggleBtn = () => {
    setPasswordShow(!passwordShow);
  };
  const handlerStepBack = () => {
    simplyClick("cl_lnd_afm3_password_back");
    setStep(step - 1);
  };

  return (
    <div className="password__form">
      <h5 className="form__title">What are you looking for?</h5>
      <div className="group__top">
        <Indicator
          textLabel={joinReasons[9].label}
          iconIndicator={HeartsIcon}
          initialClassName="component-1"
          isActive={selectedIndicator === joinReasons[9].label}
          onClick={() => handleSelectIndicator(9)}
        />
        <Indicator
          textLabel={joinReasons[11].label}
          iconIndicator={confettiIcon}
          initialClassName="component-2"
          isActive={selectedIndicator === joinReasons[11].label}
          onClick={() => handleSelectIndicator(11)}
        />
        <Indicator
          textLabel={joinReasons[10].label}
          iconIndicator={chatIcon}
          initialClassName="component-3"
          isActive={selectedIndicator === joinReasons[10].label}
          onClick={() => handleSelectIndicator(10)}
        />
      </div>
      <div className="group__bottom">
        <Indicator
          textLabel={joinReasons[12].label}
          iconIndicator={LovelyIcon}
          initialClassName="component-3"
          isActive={selectedIndicator === joinReasons[12].label}
          onClick={() => handleSelectIndicator(12)}
        />
      </div>

      <span className="line" />
      <h5 className="form__title">Create a strong password</h5>
      <div className="password__box">
        <div className="password__wrapper">
          <div className="has-float-label">
            <InputGlobal
              className={
                "input__global password" + (error?.password ? " error" : "")
              }
              onChange={(e) => handlerAddPassword(e)}
              name={"password"}
              placeholder={"Enter your password"}
              type={passwordShow ? "text" : "password"}
              id={"password"}
              value={data.password ? data.password : ""}
              onFocus={() => {
                if (!data.password) {
                  setShowTooltip(true);
                }
                simplyClick("cl_lnd_afm3_password_type_password");
              }}
              onBlur={() => setShowTooltip(false)}
            />
            <label
              htmlFor="password"
              className={error?.password ? " error" : ""}
            >
              Enter your password
            </label>
            {error?.password && <p className="error-text">{error?.password}</p>}
            <Tooltip
              text="Your password must be at least 5 characters long. You can recover it using the email you provided."
              showTooltip={showTooltip}
              className="password"
            />
          </div>
          <button onClick={toggleBtn} className="logo__eye">
            {passwordShow ? (
              <img src={Eye} alt="icon" />
            ) : (
              <img src={EyeOff} alt="icon" />
            )}
          </button>
        </div>
        <div className="terms__wrapper">
          <input
            checked={checkBox}
            onChange={(e) => handleCheckBox(e)}
            type="checkbox"
            id="remember_me"
            className={"checkBox" + (error?.terms ? " error" : "")}
            name="remember"
            value="1"
          />
          <label htmlFor="remember_me">
            <span>
              <span> I have read and understood, and I agree with the </span>
              <span>
                <a href="/terms-of-use/" target="_blank">
                  Terms of Use
                </a>
                ,&nbsp;
              </span>
              <span>
                <a href="/privacy-policy/" target="_blank">
                  Privacy Policy
                </a>
                ,&nbsp;
              </span>
              <span>
                <a href="/cookie-policy/" target="_blank">
                  Cookie Policy
                </a>
                ,&nbsp;
              </span>
              <span>
                <a href="/billing-policy/" target="_blank">
                  Billing
                </a>
                &nbsp;&&nbsp;
              </span>
              <span>
                <a href="/refund-policy/" target="_blank">
                  Refund Policy
                </a>
                &nbsp;
              </span>
              &nbsp;
              <span>and </span>
              &nbsp;
              <span>
                <a href="/consent-policy/" target="_blank">
                  Consent Policy
                </a>
              </span>
            </span>
          </label>
          {error?.terms && <p className="error-text">{error?.terms}</p>}
        </div>
        <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
      </div>
    </div>
  );
};
export default Password;
